import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Attach admin token if present (sessionStorage), but never overwrite an explicit
// Authorization header (e.g. the customer token passed by fetchMyOrders/cancelMyOrder).
api.interceptors.request.use((config) => {
  if (config.headers.Authorization) return config;
  const token = sessionStorage.getItem("gt_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fetchProducts = (category) =>
  api.get("/products", { params: category && category !== "all" ? { category } : {} }).then((r) => r.data);

export const fetchProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);

export const createOrder = (payload) => api.post("/orders", payload).then((r) => r.data);
export const trackOrder = (orderId) => api.get(`/orders/track/${orderId}`).then((r) => r.data);

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const uploadCustomCakeImage = (formData) => api.post("/custom-cake/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);

// Blog / articles (public)
export const fetchBlogPosts = () => api.get("/blog").then((r) => r.data);
export const fetchBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);

// Customer WhatsApp OTP auth (demo mode)
const customerAuth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("gt_customer_token") || ""}` } });
export const sendOtp = (phone) => api.post("/auth/whatsapp/send", { phone }).then((r) => r.data);
export const verifyOtp = (phone, otp, name) => api.post("/auth/whatsapp/verify", { phone, otp, name }).then((r) => r.data);
export const fetchMyOrders = () => api.get("/my-orders", customerAuth()).then((r) => r.data);
export const cancelMyOrder = (id) => api.post(`/orders/${id}/cancel`, {}, customerAuth()).then((r) => r.data);
export const getProfile = () => api.get("/customer/profile", customerAuth()).then((r) => r.data);
export const updateProfile = (payload) => api.put("/customer/profile", payload, customerAuth()).then((r) => r.data);
export const addAddress = (payload) => api.post("/customer/addresses", payload, customerAuth()).then((r) => r.data);
export const deleteAddress = (id) => api.delete(`/customer/addresses/${id}`, customerAuth()).then((r) => r.data);

// Customer reviews & ratings (public)
export const fetchReviews = () => api.get("/reviews").then((r) => r.data);
export const submitReview = (payload) => api.post("/reviews", payload).then((r) => r.data);

// Admin
export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => r.data);
export const fetchOrders = () => api.get("/orders").then((r) => r.data);
export const updateOrderStatus = (id, status) =>
  api.put(`/orders/${id}/status`, { status }).then((r) => r.data);
export const fetchStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminCreateProduct = (payload) => api.post("/products", payload).then((r) => r.data);
export const adminUpdateProduct = (id, payload) => api.put(`/products/${id}`, payload).then((r) => r.data);
export const adminDeleteProduct = (id) => api.delete(`/products/${id}`).then((r) => r.data);

// Admin: review moderation
export const adminListReviews = () => api.get("/admin/reviews").then((r) => r.data);
export const adminListEnquiries = () => api.get("/admin/enquiries").then((r) => r.data);

// Admin: blog
export const adminListBlog = () => api.get("/admin/blog").then((r) => r.data);
export const adminCreateBlog = (payload) => api.post("/admin/blog", payload).then((r) => r.data);
export const adminUpdateBlog = (id, payload) => api.put(`/admin/blog/${id}`, payload).then((r) => r.data);
export const adminDeleteBlog = (id) => api.delete(`/admin/blog/${id}`).then((r) => r.data);
export const adminUpdateReview = (id, status) => api.put(`/admin/reviews/${id}`, { status }).then((r) => r.data);
export const adminDeleteReview = (id) => api.delete(`/admin/reviews/${id}`).then((r) => r.data);

// Blocked delivery dates (holidays)
export const fetchBlockedDates = () => api.get("/blocked-dates").then((r) => r.data);
export const adminAddBlockedDate = (date) => api.post("/admin/blocked-dates", { date }).then((r) => r.data);
export const adminDeleteBlockedDate = (date) => api.delete(`/admin/blocked-dates/${date}`).then((r) => r.data);

export default api;
